import {APP_NAME} from 'services/constants'
import {JSONCache} from 'services/cache'

export default new JSONCache(`${APP_NAME}/token`, localStorage)
